export enum MedicalTests {
    LAB_TEST_OR_XRAY = "Lab test or X-Ray",
    MAJOR_DIAGNOSTIC_PROCEDURE = "Major diagnostic procedure (diagnostic radiology)",
    INVASIVE_DIAGNOSTIC_PROCEDURE = "Invasive diagnostic procedure"
}